import { Pipe, PipeTransform } from '@angular/core';

import { EuiMenuItem } from '../models/eui-menu-item.model';

@Pipe({
    name: 'euiMenuTooltipContent',
})
export class EuiMenuTooltipContent implements PipeTransform {
    transform(item: EuiMenuItem, externalLinkLabel: string): string {

        let tooltipContent = '';
        if (item.tagLabel && item.urlExternal) {
            tooltipContent = item.label + ' (' + item.tagLabel + ')' + ' (' + externalLinkLabel + ')';
        } else {
            if (item.tagLabel) {
                tooltipContent = item.label + ' (' + item.tagLabel + ')';
            } else {
                if (item.urlExternal) {
                    tooltipContent = item.label + ' (' + externalLinkLabel + ')';
                } else {
                    tooltipContent = item.label;
                }
            }
        }

        return tooltipContent;
    }
}
